import { render, staticRenderFns } from "./copy-price-list.vue?vue&type=template&id=0b80d318"
import script from "./copy-price-list.vue?vue&type=script&lang=js"
export * from "./copy-price-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports